export default __webpack_public_path__ + "static/media/Kapitify.6124bf4c.jpg";